import React, { Component } from "react";
import { isIOS, isMobileOnly } from "react-device-detect";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Login from "../auth/login/Login";
import { UserContext } from "../auth/providers";
import { AppString } from "../firebase/AppString";
import {
  addLoginAnalytics,
  firestore,
  getProjectData,
  getProjectRealTimeData,
  getUserDetails,
  turnOnUserCard,
} from "../firebase/firebase";
import Home from "../Home/Home";
import Home2 from "../Home/Home2";

class Application extends Component {
  state = {
    loading: false,
    canEnter: false,
    imageLoaded: false,
    loading: true,
    showIntro: false,
    live: false
  };


  getLiveStatus = () => {
    firestore.collection(AppString.BACKSATGE).doc("liveStatus").onSnapshot((res) => {
      if (res.exists) {
        window.parent.eventLive = res.data().live
        this.setState({ live: res.data().live })
      }
    })
  }
  componentDidMount() {
    this.getLiveStatus()
    // document.addEventListener("visibilitychange", (event) => {
    //   if (document.visibilityState == "visible") {
    //     console.log("tab is active");
    //     var elem = document.body;

    //     if (elem.requestFullscreen) {
    //       elem.requestFullscreen();
    //     } else if (elem.webkitRequestFullscreen) {
    //       /* Safari */
    //       elem.webkitRequestFullscreen();
    //     } else if (elem.msRequestFullscreen) {
    //       /* IE11 */
    //       elem.msRequestFullscreen();
    //     }
    //   } else {
    //     console.log("tab is inactive");
    //   }
    // });
    // window.addEventListener("keydown", (e) => {
    //   console.log(e.key);
    //   return;
    // });

    var checkMacV = () => {
      const agent = window.navigator.userAgent;
      if (agent.includes("Mac") || agent.includes("MAC") || agent.includes("mac")) {
        if (agent.includes("Version/15")) {
          window.parent.isMac15 = true;
        } else {
          window.parent.isMac15 = false;
        }
      }
    }
    checkMacV();
    var checkVersion = function () {
      var agent = window.navigator.userAgent,
        start = agent.indexOf("OS");
      if (
        (agent.indexOf("iPhone") > -1 || agent.indexOf("iPad") > -1) &&
        start > -1
      ) {
        window.parent.ios_V = window.Number(
          agent.substr(start + 3, 3).replace("_", ".")
        );
        return window.parent.ios_V;
      }
      window.parent.ios_V = null;
      return 0;
    };
    const ver = checkVersion();

    var checkVersionV2 = function () {
      var agent = window.navigator.userAgent,
        start = agent.indexOf("OS");
      if (
        (agent.indexOf("iPhone") > -1 || agent.indexOf("iPad") > -1) &&
        start > -1
      ) {
        window.parent.ios_V2 = agent.substr(start + 3, 4).replace("_", ".");

        return window.parent.ios_V2;
      }
      window.parent.ios_V2 = null;
      return 0;
    };
    const ver2 = checkVersionV2();
    if (isMobileOnly) {
      document.addEventListener("click", () => {
        var elem = document.body;
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
        } else if (elem.webkitRequestFullscreen) {
          elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) {
          elem.msRequestFullscreen();
        }
      });
    }
    if (localStorage.getItem("introVisited")) {
      this.setState({ showIntro: false });
    } else {
      this.setState({ showIntro: true });
      if (window.parent.mute) window.parent.mute();
    }
    window.app = this;
  }

  getCurrentTimeStampV2 = () => {
    return new Promise(async (resolve, reject) => {
      resolve(
        `${new Date().getFullYear()}-${new Date().getMonth() + 1
        }-${new Date().getDate()}`
      );
      // try {
      //   const res = await fetch("https://dj-timeserver.glitch.me");
      //   const result = await res.json();
      //   var currDateWeb = new Date(result.epoch);
      //   var currDateLocal = new Date();
      //   var webTimeDiff = currDateWeb.getTime() - currDateLocal.getTime();
      //   let todaysDateTimestamp = `${currDateWeb.getFullYear()}-${
      //     currDateWeb.getMonth() + 1
      //   }-${currDateWeb.getDate()}`;
      //   resolve({ currDateWeb, webTimeDiff, todaysDateTimestamp });
      // } catch (err) {
      //   reject(err);
      // }
    });
  };
  getSpeakersUid = () => {
    return new Promise((resolve, reject) => {
      try {
        firestore
          .collection("Admin")
          .doc("AdminUsers")
          .get()
          .then((doc) => {
            if (doc.exists) {
              if (doc.data().speakersUID.includes(this.context.uid)) {
                window.isSpeaker = true;
              } else {
                window.isSpeaker = false;
              }
              resolve("");
            } else {
            }
          });
      } catch (err) {
        console.log(err);
        reject("");
      }
    });
  };
  videoCallAdmin = () => {
    return new Promise((resolve, reject) => {
      try {
        firestore
          .collection("dailyco")
          .doc("East&North")
          .get()
          .then((doc) => {
            if (doc.exists) {
              if (doc.data().admin.includes(this.context.uid)) {
                window.isSpeaker = true;
                resolve(true);
              } else {
                window.isSpeaker = false;
                resolve(false);
              }
            } else {
            }
          });
      } catch (err) {
        reject("");
      }
    });
  };
  checkIfSpearker = () => {
    return new Promise((res, rej) => {
      firestore
        .collection("Admin")
        .doc("speakers")
        .onSnapshot((query) => {
          if (query.data().UID.includes(this.context.uid)) {
            window.isSpeaker = true;
            this.setState({ loading: !this.state.loading });
            res();
          } else {
            window.isSpeaker = false;
            this.setState({ loading: !this.state.loading });
            res();
          }
        });
    });
  };
  appConfig = async (userAuth) => {
    this.setState({ loading: true });
    try {
      this.setState({
        canEnter: false,
      });
      let img = new Image();
      img.src =
        "https://storage.googleapis.com/diageo-video-call.appspot.com/No.1.png";
      img.onload = () => {
        this.setState({ imageLoaded: true });
      };
      // const { todaysDateTimestamp } = await this.getCurrentTimeStampV2();
      const todaysDateTimestamp = await this.getCurrentTimeStampV2();
      console.log(todaysDateTimestamp);
      window.todaysDateTimestamp = todaysDateTimestamp;
      // await getProjectRealTimeData();
      await getProjectData();
      await this.checkIfSpearker();
      // const checkForSpeakers = await this.videoCallAdmin();
      // if (!checkForSpeakers) {
      //   await this.getSpeakersUid();
      // }
      this.setState({
        canEnter: true,
      });
      // turnOnUserCard(userAuth.email);
    } catch (error) {
      console.log(error);
      this.setState({ loading: false });
    }
  };

  render() {
    let user = this.context;
    return (
      <>
        {/* <a href="https://www.dfw.com.sg/" target="_blank">
          <div
            className={`branding ${
              !isIOS && isMobileOnly ? "mobile-branding" : ""
            } ${
              user && this.state.canEnter && this.state.imageLoaded
                ? ""
                : "mobile-login-branding"
            }`}
          >
            <p>Managed & Developed by DFW CREATIVE Pte Ltd</p>
          </div>
        </a> */}
        {user && this.state.canEnter && this.state.imageLoaded ? (
          <div onContextMenu={(e) => e.preventDefault()}>
            <Router>
              <Switch>
                <Route path="/">
                  <Home2 showIntro={this.state.showIntro}></Home2>
                </Route>
              </Switch>
            </Router>
          </div>
        ) : (
          <Router>
            <Switch>
              <Route path="/">
                <Login
                  webTimeDiff={this.state.webTimeDiff}
                  showLoggingIn={user ? true : false}
                  loading={this.state.loading}
                />
              </Route>
            </Switch>
          </Router>
        )}
      </>
    );
  }
}
Application.contextType = UserContext;
export default Application;
